import { render, staticRenderFns } from "./WorkQuestion.vue?vue&type=template&id=1bb15b4d&"
import script from "./WorkQuestion.vue?vue&type=script&lang=js&"
export * from "./WorkQuestion.vue?vue&type=script&lang=js&"
import style0 from "./WorkQuestion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports